import React, { useState } from 'react';
import { Upload, message } from 'antd';
import { Progress } from 'antd';
import './Styles/ProductRouteStyle.scss'
import { Icon } from '@material-ui/core';
import DataTable from '../../../ShearCompo/DataTable/DataTable';
import { Form } from 'react-bootstrap';

const Media = () => {
    let [uploadImage, setUploadImage] = useState([])
    console.log(uploadImage);
    let handleClearList = () => { setUploadImage([]) }
    let [serial] = useState(1)

    // let Remove = (e) => {
    //     let removed = uploadImage.splice(e, e );
    //     setUploadImage(removed)
    // }
    const props = {
        name: 'file',
        multiple: true,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange(info) {
            setUploadImage(info.fileList)
            const { status } = info.file;
            if (status === 'done') { message.success(`${info.file.name} file uploaded successfully.`); }
            else if (status === 'error') { message.error(`${info.file.name} file upload failed.`); }
        },
        onDrop(e) { console.log('Dropped files', e.dataTransfer.files) },

    };

    // Table Information
    const mediaFakeData = [
        {
            id: '1',
            imageURL: 'admin.shopkpr.com/media/2021/image.jpg',
            thumbnail: '1.png',
            title: 'Cover Photo',
            uploadedOn: '2020-01-01',
            altText: 'Featured Image',
        },
        {
            id: '2',
            imageURL: 'admin.shopkpr.com/media/2021/image.jpg',
            thumbnail: '1.png',
            title: 'Cover Photo',
            uploadedOn: '2020-01-01',
            altText: 'Featured Image',
        },
        {
            id: '3',
            imageURL: 'admin.shopkpr.com/media/2021/image.jpg',
            thumbnail: '1.png',
            title: 'Cover Photo',
            uploadedOn: '2020-01-01',
            altText: 'Featured Image',
        },
        {
            id: '4',
            imageURL: 'admin.shopkpr.com/media/2021/image.jpg',
            thumbnail: '1.png',
            title: 'Cover Photo',
            uploadedOn: '2020-01-01',
            altText: 'Featured Image',
        },
    ]
    const tableHeading = ['Image URL', 'Thumbnail', 'Title', 'Uploaded ON', 'Alt Text', 'Action']

    const tableEdit = (id) => {
        console.log(id);
        // Table Editable Function

    }



    return (
        <>
            <div className="adminBtn d-flex justify-content-between">
                <div className="d-flex csvPdfParent">
                    <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                        <Icon className="MainLightGreen">download</Icon>
                        <span>Download CSV</span>
                    </div>&nbsp;&nbsp;&nbsp;
                    <div className="d-flex align-items-center singleBtn MainLightGreen mx-0">
                        <Icon className="MainLightGreen">download</Icon>
                        <span>Download PDF</span>
                    </div>
                </div>
            </div>

            <div className="UploadBox">
                <div className="row">
                    <p className="col-lg-6 mt-2 ">Photo Gallery</p>
                    <p className="col-lg-6 mt-2 text-end" ><span className="proTip ">Pro Tip:</span>The table is editable and you can edit information about the media.</p>
                </div>
                <div className="col-lg-12 ">
                    <div>
                        <Upload.Dragger showUploadList={false} {...props} name="files" noStyle={false}>
                            <Icon className="MainLightGreen">image</Icon>
                            <Icon className="MainLightGreen">image</Icon>
                            <Icon className="MainLightGreen">image</Icon>
                            <Icon className="MainLightGreen">image</Icon>
                            <Icon className="MainLightGreen">image</Icon>
                            <p className="ant-upload-hint">Click or Drag & drop photos.The photo(s) must be JPG or PNG.The size of each photo must be below 1MB</p>
                        </Upload.Dragger>
                        <small>The resolution must be 1920X1080 and it must maintain 16:9.</small>
                    </div>
                    <br />
                    <span>Queue</span>
                    <div className="queue bg-white">
                        {uploadImage?.map((data, index) => <div className="row" key={index}>
                            <div className="col-lg-2 mt-3">
                                <i className="far fa-times-circle  removeIcon"></i> <span className="pt-5 ml-2 removeText" >Remove</span>
                            </div>
                            <div className="col-lg-2 mt-4"> <p className="csvName" title={data.name}>{data.name}</p>  </div>
                            <div className="col-lg-2 mt-3">
                                {data.status === "done" ? <button className="bulkBtn uploaded">Uploaded</button> : data.status === "error" ?
                                    <button className=" failed bulkBtn">Failed</button> : <button className=" uploading bulkBtn">Uploading</button>}
                            </div>
                            <div className="col-lg-6 mt-4 mr-3">
                                <Progress percent={parseInt(data.percent)} />

                            </div>
                        </div>)}
                        {uploadImage.length === 0 ? "" : <button className="btn btn-success px-4 py-3 mt-3 mb-5 col-lg-6 offset-lg-3 " onClick={handleClearList}>Clear The List</button>}
                    </div>
                </div>
            </div>
            <DataTable
                tableInputFrom={
                    <Form className="row p-0 tableSearch topInputFrom" id="topInputFrom1">
                        <div className="row col-lg-7 align-items-center">
                            <div className="d-flex rounded border border-success align-items-center p-2">
                                <Icon className="MainDarkGreen">information</Icon>
                                <small>Double click to edit the table and hit enter in your keyboard to save changes.</small>
                            </div>
                        </div>
                        <div className="form-bd shadow-sm rounded col-lg-5">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button id="button-addon3" type="submit" className="btn btn-link text-muted d-flex align-items-center">
                                        <Icon className="mt-1">search</Icon>
                                    </button>
                                </div>
                                <input type="search" placeholder="Search" className=" topSearchInput form-control rounded " />
                            </div>
                        </div>
                    </Form>
                }
                tableHeading={tableHeading} tableBodyData={
                    mediaFakeData && mediaFakeData.map((tableData, index) =>
                        <tr key={index} className="text-center">
                            <td>{tableData.imageURL}</td>
                            <td><img className="w-25" src={tableData.thumbnail} /></td>
                            <td data-editable="true"> {tableData.title} </td>
                            <td> {tableData.uploadedOn} </td>
                            <td data-editable="true"> {tableData.altText}</td>
                            <td className="d-flex justify-content-center align-items-center">
                                <span className="cursorPointer MainDarkGreen" onClick={() => tableEdit(tableData.id)}>
                                    <i className="fas fa-pencil-alt"></i>&nbsp;Edit
                                </span>
                                &nbsp;&nbsp;&nbsp;
                                <span className="cursorPointer LIGHT_RED">
                                    <i className="far fa-trash-alt"></i>&nbsp;Delete
                                </span>
                            </td>
                        </tr>
                    )
                } />
        </>

    );
};

export default Media;